import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const ExperienceSection = styled.section`
  padding: 5rem 2rem;
  background: #ffffff;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
`;

const Timeline = styled.div`
  position: relative;
  max-width: 800px;
  margin: 0 auto;

  &::after {
    content: '';
    position: absolute;
    width: 2px;
    background: #333;
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -1px;

    @media (max-width: 768px) {
      left: 31px;
    }
  }
`;

const TimelineItem = styled(motion.div)`
  padding: 10px 40px;
  position: relative;
  width: 50%;
  left: ${props => (props.$isLeft ? '0' : '50%')};
  
  @media (max-width: 768px) {
    width: 100%;
    padding-left: 70px;
    left: 0;
  }
`;

const TimelineContent = styled.div`
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);

  h3 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #333;
  }

  .date {
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 1rem;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  li {
    margin-bottom: 0.5rem;
    font-size: 1rem;
    color: #444;
  }
`;

const experiences = [
  {
    title: "Dong-A University DevDay (1'st Prize)",
    date: "2023.06 - 2023.08",
    description: "Platform for recommending real estate in the food service industry and calculating appropriate delivery fees (Java, Spring)"
  },
  {
    title: "2024 SW Talent Festival Participation",
    date: "2023.10",
    description: "Pitching of DevDay works and networking as a representative of Dong-A University students (KINTEX)"
  },
  {
    title: "Dong-A University DevDay (3'st Prize)",
    date: "2023.11 - 2024.12",
    description: "Development of a web note that transforms learning materials into a knowledge graph"
  },
  {
    title: "AWS 2024 Summit Korea",
    date: "2024.03.01",
    description: "Learning AWS use cases and best practices"
  },
  {
    title: "Bukyung ICT Innovation (2'st Prize)",
    date: "2024.07 - 2024.09",
    description: "Development of a platform for national health analysis and legal support through real-time atmospheric diffusion prediction based on TMS"
  },
  {
    title: "Dong-A University DevDay (1'st Prize)",
    date: "2024.11.14",
    description: "Website Carbon Emission Analysis and Web Page Lightweight AI Solution"
  },
  {
    title: "Project Bloom 2024 SW Development Contest (2'st Prize)",
    date: "2024.09 - 2024.12",
    description: "[ECO-WEB] Public Institution Carbon Neutral Website Construction Solution SW"
  },
  {
    title: "Hackathon 2025 Regional Problem-Solving Union Hackathon Competition (1'st Prize)",
    period: "2025.02.17 - 2025.02.18",
    description: "A knowledge management and sharing platform for the regional industry of Busan Metropolitan City, providing a solution for systematically managing the technological heritage of the manufacturing and shipbuilding industries."
  },
  {
    title: "Busan Public Data Startup Competition (1'st Prize)",
    period: "2025.05.15 - 2025.07.11",
    description: "Carbon measurement and AI-powered sustainability assessment service for public websites."
  },
  {
    title: "Shenzhen University International Hackathon (2'st Prize)",
    period: "2025.07.19 - 2025.07.27",
    description: "An AI Agent for Assisting International Graduate School Applications: Requirement Analysis, Eligibility Matching, and Document Generation Support"
  }
];

const Experience = () => {
  return (
    <ExperienceSection id="experience">
      <Container>
        <Title>Experience</Title>
        <Timeline>
          {experiences.map((exp, index) => (
            <TimelineItem
              key={index}
              $isLeft={index % 2 === 0}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <TimelineContent>
                <h3>{exp.title}</h3>
                <div className="date">{exp.date}</div>
                <ul>
                  <li>{exp.description}</li>
                </ul>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </Container>
    </ExperienceSection>
  );
};

export default Experience;
